import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import './node-style.css'

const propTypes = {
    nodeData: PropTypes.object.isRequired
}

const cardStyle = {
    maxWidth: '300px', 
    width: 'auto', 
    minWidth: '250px', 
    paddingTop: 5, 
    paddingBottom: 5, 
    paddingLeft: 12, 
    paddingRight: 12,
    border: '1px solid #215a88'
}


const CustomNode = ({ nodeData }) => {

    return (
        <Fragment>
            {nodeData &&
                <Fragment>
                    {!nodeData.work_unit_name  ? 
                        <div style={{ border: '1px solid #647BE9', minHeight: 130 }}>
                        </div>
                        : 
                        <div className="nodeBox">
                            <div className="position">{nodeData.work_unit_name}</div>
                            {nodeData.employee_full_name &&
                                <div className="fullname">{nodeData.employee_full_name}</div>
                            }
                        </div>
                    }
                </Fragment>
            }
        </Fragment>
    )
}

CustomNode.propTypes = propTypes

export default CustomNode
